import { render, staticRenderFns } from "./InventoryDailySnapshots.vue?vue&type=template&id=65342454"
import script from "./InventoryDailySnapshots.vue?vue&type=script&lang=js"
export * from "./InventoryDailySnapshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports